import * as React from "react";
import {useProductDetailsQuery} from "../../../../../hooks/useProductDetailsQuery";

export const IncludedWithProduct = () => {
    const {model: {componentDescription}} = useProductDetailsQuery();

    // If the componentDescription is not null upon resolution of the query, then return the following:
    if (componentDescription) {
        return (
            <div className="mb-3 mb-3">
                <span className="fw-bold me-1">Includes:</span>
                <span>{componentDescription}</span>
            </div>
        )
    }

    // Otherwise, return nothing
    return <></>;
}